import React, { useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { Tr, Td, Label, Input } from './css';
import getFormattedPricing from '../../utils';
import FieldGuide from '../../../../form/fields/common/fieldGuide';
import { CheckboxLabel } from '../../ratePlans/components/css';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';

const Row = ({ rowData, viewType, service, setService }) => {
  const {
    fields: { addonName, unitPrice, unitPrice50InUs, toolTip }
  } = rowData;
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: { moreThan50InUS }
  } = localizedStrings;

  const [quantity, setQuantity] = useState(() =>
    _.get(service, `${addonName}.quantity`, 0)
  );
  const [price, setPrice] = useState(unitPrice);
  const [fiftyPercentInUS, setFiftyPercentInUS] = useState(() =>
    _.get(service, `${addonName}.fiftyPercentInUS`, false)
  );
  const isComponentMounted = useRef(false);
  const rowRef = useRef(false);
  const key = `geotabBundles-${addonName}-fiftyPercentInUS`;
  const is50InUSCheckBoxVisible =
    unitPrice50InUs && viewType === 'advancedView';

  const handleQuantityChange = e => {
    const {
      target: { value }
    } = e;
    setQuantity(+value);
  };

  useEffect(() => {
    if (!isComponentMounted.current) {
      isComponentMounted.current = true;
      return;
    }

    setService(previousValue => {
      const updatedRatePlans = {
        ...previousValue,
        [addonName]: {
          quantity,
          unitPrice: price,
          fiftyPercentInUS
        }
      };
      return updatedRatePlans;
    });
  }, [quantity, price]);

  useEffect(() => {
    setPrice(fiftyPercentInUS ? unitPrice50InUs : unitPrice);
  }, [fiftyPercentInUS]);

  useEffect(() => {
    if (viewType && rowRef.current) {
      setQuantity(0);
      setPrice(
        is50InUSCheckBoxVisible && fiftyPercentInUS
          ? unitPrice50InUs
          : unitPrice
      );
    }
    rowRef.current = true;
  }, [viewType]);

  return (
    <Tr>
      <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
          <Label>{addonName}</Label>
          {toolTip && (
            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
              <FieldGuide tooltip={toolTip} />
            </div>
          )}
        </div>
        {is50InUSCheckBoxVisible && (
          <div
            key={key}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <label htmlFor={key} className="input-checkbox-container">
              <CheckboxLabel>{moreThan50InUS}</CheckboxLabel>
              <input
                type="checkbox"
                id={key}
                name={key}
                value={key}
                onChange={() => setFiftyPercentInUS(!fiftyPercentInUS)}
                checked={fiftyPercentInUS}
              />
              <span className="checkmark"></span>
            </label>
          </div>
        )}
      </Td>
      <Td>3 year</Td>
      <Td>
        <Input
          className="frg-input-field color-light"
          pattern="[0-9]"
          value={quantity}
          onChange={handleQuantityChange}
        />
      </Td>
      <Td>
        <Label>{getFormattedPricing(price)}</Label>
      </Td>
      <Td>
        <Label>{getFormattedPricing(price * quantity)}</Label>
      </Td>
    </Tr>
  );
};

Row.propTypes = {
  rowData: PropTypes.shape({
    fields: PropTypes.shape({
      addonName: PropTypes.string,
      unitPrice: PropTypes.number,
      unitPrice50InUs: PropTypes.number,
      toolTip: PropTypes.string
    })
  }).isRequired,
  viewType: PropTypes.string.isRequired,
  service: PropTypes.shape({}).isRequired,
  setService: PropTypes.func.isRequired
};

export default Row;
